import {
  FactoryComponent,
  PlantComponent,
  ResourceComponent,
  storageTextObj,
} from '@components/helpers/ObjectsText';
import { type TFunction } from 'i18next';

import { toCapitalizeStr } from './toCapitalizeStr';

interface GetTextPropsType {
  name: string;
  kind: 'build' | 'resource';
  t: TFunction;
}

const getText = ({ name, kind, t }: GetTextPropsType): string | undefined => {
  if (name === 'cash' || name === 'tgem') {
    return toCapitalizeStr(name);
  }

  const resourceNames = storageTextObj(t);

  if (name in resourceNames && kind === 'resource') {
    return resourceNames[name];
  }

  const resourceText = ResourceComponent(t);

  if (name in resourceText) {
    const textObj = resourceText[name as keyof typeof resourceText];

    return kind === 'build' ? textObj.nameFactory : textObj.nameMaterial;
  }

  const plantText = PlantComponent(t);

  if (name in plantText) {
    const textObj = plantText[name as keyof typeof plantText];

    return kind === 'build' ? textObj.nameFactory : textObj.nameMaterial;
  }

  const factoryText = FactoryComponent(t);

  if (name in factoryText) {
    const textObj = factoryText[name as keyof typeof factoryText];

    return kind === 'build' ? textObj.nameFactory : textObj.nameMaterial;
  }
};

export { getText };
